import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const rootCSS = `
html, body, #root {
    margin: 0px;
    padding: 0px;
    font-family: sans-serif;
    height: 100%;
    overflow: auto;
}
`;
export const loaderCSS = `
.LoadingCircle {
    animation: LoadingCircle 2s infinite;
    animation-timing-function: linear;
}
  
@keyframes LoadingCircle {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}  
`;
export const loaderHTML = `<div style="background-color: #090909; height: 100%; width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 20px; user-select: none;"><img src="https://cdn.hiyllo.net/logo/hiyllo/icon-gradient.png" style="height: 50px; width: 50px;"><div style="width: 200px; height: 5px; border-radius: 2.5px; overflow: hidden; background: rgb(25, 25, 25);"><div class="LoadingBar" style="border-radius: 2.5px; overflow: hidden; background: linear-gradient(to right, rgb(254, 2, 254), rgb(254, 143, 1)); height: 100%;"></div></div></div>`;
export const LoadingPage = React.memo(function LoadingPage(props) {
    return (_jsxs("div", { style: {
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 20,
            userSelect: "none",
            backgroundColor: "#090909"
        }, children: [props.label != null ?
                _jsx("div", { style: {
                        fontSize: 40,
                        fontFamily: "hiyllo",
                        fontWeight: "bold",
                    }, children: props.label ?? "Hiyllo" })
                :
                    _jsx("img", { src: props.logo ?? "https://cdn.hiyllo.net/logo/hiyllo/icon-gradient.png", style: {
                            height: 50,
                            width: 50
                        } }), _jsx("div", { style: {
                    width: 200,
                    height: 5,
                    borderRadius: 2.5,
                    overflow: "hidden",
                    background: "#191919"
                }, children: _jsx("div", { className: "LoadingBar", style: {
                        borderRadius: 2.5,
                        overflow: "hidden",
                        background: "linear-gradient(to right, rgb(254 2 254), rgb(254 143 1))",
                        height: "100%"
                    } }) })] }));
});
